"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.thunkRenderExample = thunkRenderExample;
const babel_standalone_1 = require("babel-standalone");
function thunkRenderExample(library, componentNames) {
    return (example, container) => new Promise((resolve) => {
        const { React, ReactDOM, Wrapper } = library;
        const jsxCode = getJSX(example, componentNames);
        // tslint:disable:no-eval variable-name
        const Preview = eval((0, babel_standalone_1.transform)(jsxCode, {
            presets: ['es2015', 'react'],
        }).code || '');
        if (Wrapper) {
            ReactDOM.render(React.createElement(Wrapper, undefined, Preview), container);
        }
        else {
            ReactDOM.render(Preview, container);
        }
        resolve();
    });
}
function getJSX(example, componentNames) {
    return `const { React } = library;
const { ${componentNames.join(', ')} } = library;

${example.code}`;
}
//# sourceMappingURL=thunkRenderExample.js.map